import React from 'react'
import FilterDropdown from './FilterDropdown'
import SearchFilterAggregations from '../components/SearchFilterAggregations'
import URLSearchParams from 'url-search-params'

export default class SearchFiltersNav extends React.Component {
  constructor(props) {
    super(props);
    let agg = new SearchFilterAggregations({aggs: this.props.data.aggs, role: this.props.data.role })

    this.state = {
      statuses: agg.statuses(),
      months: agg.months(),
      years: agg.years(),
      sizes: agg.sizes(),
      deadlines: agg.deadlines(),
      query: this.props.data.query,
      type: this.props.data.type
    };
    this.clearAllBtn = React.createRef();
    this.setFilters = this.setFilters.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.renderDropdown = this.renderDropdown.bind(this);
  }

  closeSideNav() {
    $('.js-open-search-filter').sideNav('hide')
  }

  setFilters() {
    let queryparams = this.buildQueryParams()
    window.location.search = `q=${this.state.query}&type=${this.state.type}${queryparams}`
  }

  clearFilters() {
    window.location.search = `q=${this.state.query}&type=${this.state.type}`
  }

  componentDidMount(){
    $('.js-open-search-filter').sideNav({edge: 'left'});
    let qp = this.buildQueryParams()
    if (qp.length){
      $(this.clearAllBtn.current).removeClass('hidden')
    }
  }

  buildQueryParams(){
    let str = ""
    $('select').each((i, ele) => {
      if (ele.value !== "All")
      str += `&${ele.id}=${ele.value}`
    })
    return str
  }

  renderDropdown(name, options) {
    if(options.length > 1) {
      let urlParams = new URLSearchParams(window.location.search);
      return <FilterDropdown options={options} name={name} default={urlParams.get(name)}/>;
    }
    else {
      return "";
    }
  }

  render() {
    return (
      <div className="side-nav medium" id="js-filters-side-nav">
        <div className="container px-3 pt-3 pb-2">
          <div className="d-flex flex-row mb-10">
            <div className="col-4 pl-0">
              <h2 className="grey-text text-darken-3 font-weight-bold">Filters</h2>
            </div>
            <div className="col-8 grey-text text-darken-3 text-right">
              <i className="material-icons cursor-pointer" onClick={this.closeSideNav}>clear</i>
            </div>
          </div>
          { this.renderDropdown("size", this.state.sizes) }
          { this.renderDropdown("status", this.state.statuses) }
          { this.renderDropdown("year", this.state.years) }
          { this.renderDropdown("month", this.state.months) }
          { this.renderDropdown("deadline", this.state.deadlines) }
          <div className="d-flex flex-row">
            <div className="m-auto text-center">
              <button className="btn btn-primary" onClick={this.setFilters}>Apply</button>
            </div>
          </div>
          <div className="d-flex flex-row">
            <div className="m-auto text-center">
              <button className="btn btn-primary hidden" ref={this.clearAllBtn} onClick={this.clearFilters}>Clear Filters</button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
